import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Form, useNavigate, useParams } from 'react-router-dom';
import FormMasterSummary from './FormMasterView/FormMasterSummary';
import FormMasterSettings from './FormMasterView/FormMasterSettings';
import FormMasterJobCategories from './FormMasterView/FormMasterJobCategories';
import FormMasterSectionCard from './FormMasterView/FormMasterSectionCard';
import Spinner from '../Spinner';
import $ from 'jquery';
import FormMasterCalculation from './FormMasterView/FormMasterCalculations';
import Modal from "react-modal";
import api from '../../api/axiosInstance';

const FormMasterView = () => {

  //Date :- 16/12/2024 Implemented the DisableFormFields functionality by Syed Adeeb Ahmed (Trainee Software Developer)
  const { id } = useParams(); // Get the form ID from the URL
  const navigate = useNavigate();
  const [form, setForm] = useState(null);
  const [formCategories, setFormCategories] = useState([]);
  const [formSubCategories, setFormSubCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [filteredSubCategories, setFilteredSubCategories] = useState([]); // Holds filtered sub-categories
  const [formJobCategories, setFormJobCategories] = useState([]);
  const [formMasterJobCategories, setFormMasterJobCategories] = useState([]);
  const [Columns, setColumns] = useState([]);
  const [formMasterSections, setFormMasterSections] = useState([]);
  const [formMasterComponents, setFormMasterComponents] = useState([]);

  const [shouldShowButton, setShouldShowButton] = useState(false);
  const loggedInUserId = localStorage.getItem('userId');
  const [waitingForApproval, setWaitingForApproval] = useState(false);
  const [approved, setApproved] = useState(false);
  const [expired, setExpired] = useState(false);
  const [published, setPublished] = useState(false);
  const shouldDisableFields = shouldShowButton === false && waitingForApproval === true || approved === true || published === true || expired === true;
  var showPreview = false;
  var showSetRecipient = false;
  const [formMasterCalculations, setFormMasterCalculations] = useState([]);
  const [availableCalculations, setAvailableCalculations] = useState([]);
  const[loading,setLoading]=useState(false);
  // Fetch data when the component mounts
  const [blocked, setBlocked] = useState(false);
  const[formType, setformType]=useState(false);
    const [refresh,setRefresh]=useState(0);
    const [addCalculation,setAddCalculation]=useState(false);
  const FetchFormData = () => {
    debugger;

    api.get(`/FormMaster/ViewFormMaster/${id}`)
      .then(response => {
        debugger;
        const { formMaster, formCategories, formSubCategories, formJobCategories, formMasterJobCategories, formMasterSections, formMasterCalculations, formMasterComponents } = response.data;
        setForm(formMaster);
        const isExternalForm=formMaster.formTypeValue===121440001;
        setformType(isExternalForm);
        debugger;
        if (formMaster.statusReasonValue) {
          if (formMaster.statusReasonValue === 121440000) {
            setWaitingForApproval(true);
          }
          if (formMaster.statusReasonValue === 121440001) {
            setApproved(true);
          }
          if (formMaster.statusReasonValue === 121440003) {
            setPublished(true);
          }
          if (formMaster.statusReasonValue === 121440004) {
            setExpired(true);
          }
        }
        setFormCategories(formCategories);
        setFormSubCategories(formSubCategories);
        setFormJobCategories(formJobCategories);
        setFormMasterSections(formMasterSections);
        setFormMasterJobCategories(formMasterJobCategories==null?[]:formMasterJobCategories);
        setSelectedCategory(formMaster.formCategoryId);
        // Initially filter sub-categories based on the current category
        filterSubCategories(formMaster.formCategoryId, formSubCategories);
        setFormMasterCalculations(formMasterCalculations);
        setFormMasterComponents(formMasterComponents);
       
        console.log(response);
      })
      .catch(error => console.error('Error fetching form data', error));
  }
  const Addcalculation=()=>
  {
    debugger;

    api.get(`FormMaster/GetFormMasterComponentsForCalculations?formMasterGuid=${id}`)
    .then(response => {
      if(response.data.length>=3)
      {
     setAddCalculation(true);
      }
      else 
      {
        setAddCalculation(false);
      }
    });
  }
  

  useEffect(() => {
    if (shouldShowButton === true) {
      showPreview = true;
      showSetRecipient = true;
    }
    debugger;
    FetchFormData();
    Addcalculation();
  }, [id,loading,refresh]);                                                                                                                                              
  useEffect(() => {
    debugger;
    if (form != null) {
      // Check if formMasterComponents and formMasterJobCategories are available and the form statusReasonValue is valid
      if (form.statusReasonValue == 1 || form.statusReasonValue == 121440002) {
        console.log("Form is waiting for approval and statusReasonValue is 121440000");
        if (formMasterComponents != null) {
          if (formMasterComponents.length > 0) {
            console.log("formMasterComponents.length > 0");  // Check if components are available
            console.log("formMasterJobCategories.length:", formMasterJobCategories.length);

            // Check additional conditions to determine if button should be shown
            if (form.formTypeValue === 121440000 && formMasterJobCategories.length > 0) {
              console.log("Condition inside internal passed");
              setShouldShowButton(true); // Show button if internal and jobcategory.count > 0
            } else if (form.formTypeValue === 121440001) {
              console.log("Condition inside external passed");
              setShouldShowButton(true); // Show button if external (regardless of jobcategory)
            } else {
              setShouldShowButton(false); // Otherwise hide the button
            }
          }
        } else {
          console.log("formMasterComponents is empty");
          setShouldShowButton(false); // Hide button if no components are available
        }
      } else {
        setShouldShowButton(false); // Hide the button if form.statusReasonValue is not 121440000 or waitingForApproval is false
      }
    }
  }, [waitingForApproval, formMasterComponents, formMasterJobCategories, form,loading]);



  // Filter sub-categories when the selected category changes
  const filterSubCategories = (categoryId, subCategories) => {
    // alert("subcate");
    debugger;
    const filtered = subCategories.filter(subCategory => subCategory.formCategoryId === categoryId);
    debugger;
    setFilteredSubCategories(filtered); // Update the filtered sub-categories
    debugger;
  };

  const handleCategoryChange = (e) => {
    debugger;
    const categoryId = e.target.value;
    setSelectedCategory(categoryId);
    // Filter the sub-categories based on the selected category
    filterSubCategories(categoryId, formSubCategories);

    // Optionally reset the sub-category when the category changes
    setForm(prevForm => ({
      ...prevForm,
      formCategoryId: categoryId,  // Update the formCategoryId directly
      formSubCategoryId: '' // Reset sub-category if needed
    }));
  };

    const handleFormChange = (field, value) => {
      debugger;
      if(field==="formTypeValue" && value==="121440001")
      {
        setformType(true);
        // setForm.forOneTimeUse=false;
      }
      else {
        setformType(false);
      }
      setForm(prevForm => ({
        ...prevForm,
        [field]: value
      }));

    };


  // Save Form Summary
  const handleSaveSummary = () => {
    $.confirm({
      title: 'Confirm Save Summary',
      content: 'Do you really want to save the changes?',
      type: 'green',
      buttons: {
        yes: {
          text: 'Yes',
          btnClass: 'btn-green',
          action: function () {
            debugger;
            form.description = '....';
            const isExternal=form.formTypeValue==="121440001";
            const finalData = {
              id: form.id, // Example GUID, should be generated on the backend or from your state
              name: form.name, // Form name from the input
              description: "No Description", // You can change this to a dynamic description
              createdByContactId: form.createdByContactId, // Assuming the logged-in user's ID (this is a GUID)
              createdByContactName: form.createdByContactName || '', // Fetch this dynamically if needed, or use logged-in user name
              modifiedByContactId: JSON.parse(localStorage.getItem('user')).id, // Same as created by
              modifiedByContactName: JSON.parse(localStorage.getItem('user')).fullName, // Same as above
              formCategoryId: form.formCategoryId, // Should be the GUID of the selected category
              formCategoryName: form.formCategoryName, // You can fetch this dynamically based on the selected category
              formSubCategoryId: form.formSubCategoryId, // Should be the GUID of the selected subcategory
              formSubCategoryName: form.formSubCategoryName, // Fetch dynamically based on the selected subcategory
              statusReasonValue: form.statusReasonValue, // Example, adapt this as necessary
              statusReasonText: form.statusReasonText, // Example, adapt this as necessary
              formTypeValue: form.formTypeValue, // Example, adapt this as necessary
              formTypeText: form.formTypeText, // Example, adapt this as necessary
              forOneTimeUse: isExternal ?false: form.forOneTimeUse, // Boolean checkbox value
              allowSubmitterToAddComment: form.allowSubmitterToAddComment, // Set as per your logic
              allowReviewerToAddComment: form.allowReviewerToAddComment, // Set as per your logic
              allowOthersToAddComment: form.allowOthersToAddComment, // Set as per your logic
              allowSubmitterToPrint: form.allowSubmitterToPrint, // Set as per your logic
              allowReviewerToPrint: form.allowReviewerToPrint, // Set as per your logic
              allowOthersToPrint: form.allowOthersToPrint, // Set as per your logic
              allowSubmitterToAddAttachment: form.allowSubmitterToAddAttachment, // Set as per your logic
              allowReviewerToAddAttachment: form.allowReviewerToAddAttachment, // Set as per your logic
              allowOthersToAddAttachment: form.allowOthersToAddAttachment, // Set as per your logic
              allowSubmitterToSelectReviewer: form.allowSubmitterToSelectReviewer, // Set as per your logic
              approvedOn: form.approvedOn, // If you need to set these dates dynamically
              createdOn: form.createdOn, // Use backend date, or this one
              modifiedOn: form.modifiedOn, // Use backend date, or this one
              expiryDate: form.expiryDate, // Set this date accordingly
              publishedOn: form.publishedOn, // Set this date accordingly
            };
   if(!finalData.formCategoryId)
{
alert("Please Select a valid Form Category ");
return;
}
if(!finalData.formSubCategoryId)
{
alert("Please Select a valid Form  SubCategory ");
return;
}
if(!finalData.formTypeValue)
{
alert("Please Select a valid Form Type ");
return;
}
  
       setBlocked(true);
            api.post(`/FormMaster/SaveFormMasterSummary`, finalData, {
              headers: {
                'Content-Type': 'application/json', // Ensure the correct content type
              }
            })
              .then(response => {
                setBlocked(false);
                $.alert({
                  title: 'Success',
                  content: 'Record saved successfully.',
                  type: 'green'
                });
                // navigate('/editor/FormMasters'); // Redirect after save
              })
              .catch(error => {
                   setBlocked(false);
                debugger;
                $.alert({
                  title: 'Error',
                  content: 'An error occurred while saving the summary.',
                  type: 'red'
                });
              });
          }
        },
        no: {
          text: 'No',
          btnClass: 'btn-red'
        }
      }
    });
  };

  // Save Form Settings
  const handleSaveSettings = () => {
    $.confirm({
      title: 'Confirm Save Settings',
      content: 'Do you really want to save the changes? ',
      type: 'green',
      buttons: {
        yes: {
          text: 'Yes',
          btnClass: 'btn-green',
          action: function () {
            setBlocked(true);
            debugger;
            const finalData = {
              id: form.id, // Example GUID, should be generated on the backend or from your state
              name: form.name, // Form name from the input
              description: "No Description", // You can change this to a dynamic description
              createdByContactId: form.createdByContactId, // Assuming the logged-in user's ID (this is a GUID)
              createdByContactName: form.createdByContactName, // Fetch this dynamically if needed, or use logged-in user name
              modifiedByContactId: JSON.parse(localStorage.getItem('user')).id, // Same as created by
              modifiedByContactName: JSON.parse(localStorage.getItem('user')).fullName, // Same as above
              formCategoryId: form.formCategoryId, // Should be the GUID of the selected category
              formCategoryName: form.formCategoryName, // You can fetch this dynamically based on the selected category
              formSubCategoryId: form.formSubCategoryId, // Should be the GUID of the selected subcategory
              formSubCategoryName: form.formSubCategoryName, // Fetch dynamically based on the selected subcategory
              statusReasonValue: form.statusReasonValue, // Example, adapt this as necessary
              statusReasonText: form.statusReasonText, // Example, adapt this as necessary
              formTypeValue: form.formTypeValue, // Example, adapt this as necessary
              formTypeText: form.formTypeText, // Example, adapt this as necessary
              forOneTimeUse: form.forOneTimeUse, // Boolean checkbox value
              allowSubmitterToAddComment: form.allowSubmitterToAddComment, // Set as per your logic
              allowReviewerToAddComment: form.allowReviewerToAddComment, // Set as per your logic
              allowOthersToAddComment: form.allowOthersToAddComment, // Set as per your logic
              allowSubmitterToPrint: form.allowSubmitterToPrint, // Set as per your logic
              allowReviewerToPrint: form.allowReviewerToPrint, // Set as per your logic
              allowOthersToPrint: form.allowOthersToPrint, // Set as per your logic
              allowSubmitterToAddAttachment: form.allowSubmitterToAddAttachment, // Set as per your logic
              allowReviewerToAddAttachment: form.allowReviewerToAddAttachment, // Set as per your logic
              allowOthersToAddAttachment: form.allowOthersToAddAttachment, // Set as per your logic
              allowSubmitterToViewHistory: form.allowSubmitterToViewHistory, // Set as per your logic
              allowReviewerToViewHistory: form.allowReviewerToViewHistory, // Set as per your logic
              allowOthersToViewHistory: form.allowOthersToViewHistory, // Set as per your logic
              allowSubmitterToSelectReviewer: form.allowSubmitterToSelectReviewer, // Set as per your logic
              approvedOn: form.approvedOn, // If you need to set these dates dynamically
              createdOn: form.createdOn, // Use backend date, or this one
              modifiedOn: form.modifiedOn, // Use backend date, or this one
              expiryDate: form.expiryDate, // Set this date accordingly
              publishedOn: form.publishedOn, // Set this date accordingly
            };

            api.post(`/FormMaster/SaveFormMasterSettings`, finalData)
              .then(response => {
                setBlocked(false);
                $.alert({
                  title: 'Success',
                  content: 'Record saved successfully.',
                  type: 'green'
                });
                // navigate('/formmasters'); // Redirect after save
              })
              .catch(error => {
                        setBlocked(false);
                $.alert({
                  title: 'Error',
                  content: 'An error occurred while saving the settings.',
                  type: 'red'
                });
              });
          }
        },
        no: {
          text: 'No',
          btnClass: 'btn-red'
        }
      }
    });
  };

  // Handle job category added (API call)
  const handleJobCategoryAdded = (newJobCategory) => {
    debugger;
    // const formMasterjobCategory = {
    //   FormMasterName: '',
    //   JobCategoryName: '',
    //   Name: '',
    //   FormMasterId: form.id,
    //   JobCat: newJobCategory.JobCategoryId,
    // }
    api.post('/FormMaster/AddFormMasterJobCategory', newJobCategory, {
      headers: {
        'Content-Type': 'application/json', // Ensure the correct content type
      }
    })
      .then(response => {
        const updatedCategories = response.data.formMasterJobCategories;

        // Update the formMasterJobCategories state with the new list
        setFormMasterJobCategories(updatedCategories);
        setFormJobCategories(prevCategories =>
          prevCategories.filter(jobCategory => jobCategory.id !== newJobCategory.JobCategoryId)
        );
        // setFormMasterJobCategories(formMasterJobCategories);
        // $.alert({
        //   title: 'Success',
        //   content: 'Record saved successfully.',
        //   type: 'green'
        // });
      })
      .catch(error => {
        console.log(error);
        $.alert({
          title: 'Error',
          content: 'An error occurred while adding the job category.',
          type: 'red'
        });
      });
  };

  // Handle job category deleted (API call)
  const handleJobCategoryDeleted = (jobCategoryId) => {
    debugger;
    setBlocked(true);
    api.delete(`/FormMaster/DeleteFormMasterJobCategory?id=${jobCategoryId}&formMasterId=${form.id}`)
      .then(response => {
        debugger;
        const updatedFormMasterJobCategories = response.data.formMasterJobCategories;
        debugger;
        const updatedJobCategories = response.data.formJobCategories;
        debugger;
        // Successfully deleted job category
        // if (updatedFormMasterJobCategories === null || updatedFormMasterJobCategories === undefined) {
        //   // If it is, clear the state (set it to an empty array)
        //   setFormMasterJobCategories(null);
        // } else {
        //   // If it's not null or undefined, update the state with the updated form master job categories
        //   setFormMasterJobCategories(updatedFormMasterJobCategories);
        // }
        const updatedFormMasterCategories = formMasterJobCategories.filter(
          (category) => category.id !== jobCategoryId
        );
        debugger;
        setFormMasterJobCategories(updatedFormMasterCategories==null?[]:updatedFormMasterCategories);
        setFormJobCategories(updatedJobCategories);
        debugger;
        setBlocked(false);
        $.alert({
          title: 'Success',
          content: 'Job Category deleted successfully.',
          type: 'green'
        });
      })
      .catch(error => {
               setBlocked(false);
        debugger;
        $.alert({
          title: 'Error',
          content: 'An error occurred while deleting the job category.',
          type: 'red'
        });
      });
  };

  const handleSaveFromMasterSection = async(formId) => {
debugger;
const finalColumns = Array.isArray(Columns) && Columns.length === 0 ? 1 : Columns;
    // Prepare the request body
    const formMasterSection = {
      id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',  // Provide a valid ID or use dynamic 'id'
      name: 'Form',  // Ensure this is a valid name
      formMasterId: id,  // This should be the actual 'id' you're passing in
      formMasterName: '', // If necessary, populate this field
      seqNo: 0, // You can either omit this field or set it to a valid number
      noOfColumns: finalColumns, // Ensure 'Columns' is a valid number (e.g., 1, 2, etc.)
      ListRows: [],
      ListComponent: []
    };
    console.log("Submitting section:", formMasterSection);

 setBlocked(true);
    await api.post(`/FormMaster/AddFormMasterSection/`, formMasterSection, {
      headers: {
        'Content-Type': 'application/json', // Ensure the correct content type
      }
    })
      .then(response => {
        debugger;
        setFormMasterSections(response.data);
        const modal = document.getElementById('modal-default');
        if (modal) {
          modal.style.display = 'none'; // Close the modal
          modal.classList.remove('show');
        }
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
        document.body.classList.remove('modal-open');
        setBlocked(false);
        $.alert({
          title: 'Success',
          content: 'Section Added successfully.',
          type: 'green'
        });

      })
      .catch(error => {                                 
        debugger;
        $.alert({
          title: 'Error',
          content: 'An error occurred while Adding the section.',
          type: 'red'
        });
      });
  }
  const handleDeleteSection = (sectionId, formMasterGuid) => {
    debugger;
    // Show confirmation dialog before deleting
    $.confirm({
      title: 'Are you sure?',
      content: 'Do you really want to delete this record?',
      type: 'red',
      buttons: {
        yes: {
          text: 'Yes',
          btnClass: 'btn-red',
          action: () => {
            setBlocked(true);
            // Construct the URL with query parameters
            const url = `/FormMaster/DeleteFormMasterSection?formMasterSectionId=${sectionId}&formMasterId=${formMasterGuid}`;

            // Send the DELETE request with the query parameters
            api.delete(url)
              .then(response => {
                debugger;
                // Handle the response (updated list of form master components)
  alert("1");
                console.log('Updated Form Master sections:', response);
                
                // setFormMasterSections(response.data);
              setRefresh(prev => prev + 1); 
                setBlocked(false);
                // Show success message on successful deletion
                $.alert({
                  title: 'Success',
                  content: 'Record deleted successfully.',
                  type: 'green'
                });

                // Optionally, refresh the list or re-fetch the data

              })
              .catch(error => {
                // Handle errors and show error message on failure
                console.error('Error deleting Section:', error.response ? error.response.data : error.message);

                $.alert({
                  title: 'Error',
                  content: 'Failed to delete the record.' + error.response ? error.response.data : error.message,
                  type: 'red'
                });
              });
          }
        },
        no: {
          text: 'No',
          btnClass: 'btn-default',
          action: function () {
            // If "No" is clicked, do nothing and just close the confirmation
          }
        }
      }
    });
  }
  const OnColumnChange = (value) => {
    setColumns(value);
  }

  // Handlers for adding and deleting calculations
  const handleCalculationAdded = (formMasterCalculation) => {
    // console.log("before Sending newCalculation to API" + newCalculation);
    // console.log(newCalculation);

    debugger;
    // console.log("before Sending newCalculation to API" + newCalculation);
    console.log(formMasterCalculation);
    api.post(`/FormMaster/AddFormMasterCalculation`, formMasterCalculation, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
      .then(response => {
        debugger;
        console.log(response);
        setFormMasterCalculations(response.data); // Update state with the new calculation
        $.alert({
          title: 'Success',
          content: 'Calculation added successfully.',
          type: 'green'
        });
      })
      .catch(error => {
        $.alert({
          title: 'Error',
          content: 'An error occurred while adding the calculation.',
          type: 'red'
        });
      });
    // setFormMasterCalculations([...formMasterCalculations, newCalculation]);
  };

  // Parent function that handles the deletion of a calculation and API call
  const onCalculationDeleted = (calculationId) => {
    debugger;
    // Make API request to delete the calculation
    api.delete(`/FormMaster/DeleteFormMasterCalculation`, {
      params: {
        formMasterCalculationId: calculationId,
        formMasterId: id,
      }
    })
      .then((response) => {

        // // On success,set the new list from response
        setFormMasterCalculations(response.data);

        // Show a success message to the user (optional)
        $.alert({
          title: 'Success',
          content: 'Calculation deleted successfully.',
          type: 'green'
        });
      })
      .catch((error) => {
        // Handle any errors during the deletion process
        $.alert({
          title: 'Error',
          content: 'An error occurred while deleting the calculation.',
          type: 'red'
        });
      });
  };

  // let shouldShowButton = false;

  // if (formMasterComponents.length > 0) {
  //   if (form.formTypeValue === 121440000 && formMasterJobCategories.length > 0){debugger;
  //     shouldShowButton = true; // Show button if internal and jobcategory.count > 0}
  //  }
  //   else if (form.formTypeValue === 121440001) {
  //     shouldShowButton = true; // Show button if external (regardless of jobcategory)
  //   }
  // }

  const handlePreviewClick = () => {
    debugger;
    console.log("clicked");
    var recordGuidStr = id;
    const userData = JSON.parse(localStorage.getItem('user')); // Get user info from localStorage
    const loggedinUserid = userData ? userData.email : null; // Get logged-in user email
    if (loggedinUserid) {
      // Navigate to FormPreviewPage with the email and recordGuidStr as query parameters
      // navigate(`/editor/form-preview?recordGuidStr=${recordGuidStr}`);
      const flag='formMaster';
      const previewUrl = `/editor/form-preview?recordGuidStr=${recordGuidStr}&flag=${flag}`;
      window.open(previewUrl, "_blank");

      // Page?recordGuidStr=${recordGuidStr}&loggedinUserid=${loggedinUserid}
    } else {
      console.error("User is not logged in or email is missing");
    }
  };

  const handleSendForApprover = () => {
    debugger;
    // Add the logic for sending the form for approval here
    $.confirm({
      title: 'Are you sure?',
      content: 'Do you really want to send for approval?',
      type: 'red',
      buttons: {
        yes: {
          text: 'Yes',
          btnClass: 'btn-red',
          action: () => {
            setBlocked(true);
            debugger;
            // Construct the URL with query parameters
            const url = `/FormMaster/SendFormForApproval?formMasterGuid=${id}`;
  debugger;
            // Send the DELETE request with the query parameters
            api.post(url)
              .then(response => {
                // Handle the response (updated list of form master components)

                console.log('Sent for Approval:', response);
                 setBlocked(false);
                // Show success message on successful deletion
                $.alert({
                  title: 'Success',
                  content: 'Successfully sent for approval.',
                  type: 'green'
                });
                FetchFormData();
                // Optionally, refresh the list or re-fetch the data

              })
              .catch(error => {
                // Handle errors and show error message on failure
                console.error('Error sending for approval:', error.response ? error.response.data : error.message);

                $.alert({
                  title: 'Error',
                  content: 'Failed to send for approval.' + error.response ? error.response.data : error.message,
                  type: 'red'
                });
              });
          }
        },
        no: {
          text: 'No',
          btnClass: 'btn-default',
          action: function () {
            // If "No" is clicked, do nothing and just close the confirmation
          }
        }
      }
    });
    console.log('Form sent for approver');
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [jobCategories, setJobCategories] = useState([]); // Fetch from API
  const [recipients, setRecipients] = useState(["All", "Manager", "Team Lead", "Employee"]);
  const [jobCategory, setJobCategory] = useState("");
  const [recipient, setRecipient] = useState("all"); // Default: "Select All"
  const [allowSubmitter, setAllowSubmitter] = useState(false);

  // Open Modal & Fetch Job Categories
  const openModal = async () => {
    setIsModalOpen(true);
    await fetchJobCategories();
  };

  // Close Modal
  const closeModal = () => {
    setIsModalOpen(false);
    resetForm();
  };

  // Reset form on modal close
  const resetForm = () => {
    setJobCategory("");
    setRecipient("all");
    setAllowSubmitter(false);
  };

  // Fetch Job Categories from API
  const fetchJobCategories = async () => {
    try {
      const response = await api.get(
        `/FormMaster/GetFormMasterJobCategoriesByFormMaster`
      );
      if (response.status === 200) {
        debugger;
        setJobCategories(response.data); // Assuming API returns an array of categories
      } else {
        console.error("Failed to fetch job categories");
      }
    } catch (error) {
      console.error("Error fetching job categories:", error);
    }
  };

  // Handle Job Category Change
  const handleJobCategoryChange = async (e) => {
    debugger;
    const selectedCategoryId = e.target.value;
    setJobCategory(selectedCategoryId);
    // setRecipient("all"); // Reset recipient
    setAllowSubmitter(false); // Reset checkbox

    if (selectedCategoryId) {
      await fetchRecipients(selectedCategoryId);
      setRecipient("all"); // ✅ Only set after recipients are loaded
    } else {
      setRecipients([]); // clear if no category
      setRecipient("");  // clear recipient
    }
  };

  // Fetch Recipients Based on Job Category
  const fetchRecipients = async (jobCategoryId) => {
    debugger;
    try {
      const response = await api.get(
        `/FormMaster/GetRecipientsOfJobcategory?jobCategoryId=${jobCategoryId}`
      );

      if (response.status === 200) {
        const data = response.data;
        console.log(response.data);
        // Extract relevant fields (id and name)
        const validRecipients = data
          .filter((recip) => recip.id && recip.name) // Ensure id and name are not null
          .map((recip) => ({ id: recip.id, name: recip.name }));
        console.log(validRecipients);
        setRecipients([{ id: "all", name: "Select All" }, ...validRecipients]); // Include "Select All"
      } else {
        console.error("Failed to fetch recipients");
      }
    } catch (error) {
      console.error("Error fetching recipients:", error);
    }
  };

  // Handle Recipients Dropdown Change
  const handleRecipientChange = (e) => {
    const selectedValue = e.target.value;
    setRecipient(selectedValue);

    // Show checkbox only if "Select All" is chosen
    if (selectedValue === "all") {
      setAllowSubmitter(false); // Reset checkbox when switching to "All"
    }
  };

  const handleSave = () => {
    debugger;
    if (!jobCategory) {
      alert("Please select a Job Category");
      return;
    }

    const currentUser = JSON.parse(localStorage.getItem("user"));

    const selectedJobCategory = jobCategory || "all";
    const selectedRecipient = recipient !== "all" ? recipient : "00000000-0000-0000-0000-000000000000";

    const payload = {
      Id: id || "00000000-0000-0000-0000-000000000000",
      Name: "dsfd",
      Description: "gdg",
      CreatedByContactId: currentUser?.id || "00000000-0000-0000-0000-000000000000",
      CreatedByContactName: currentUser?.fullName || "Unknown User",
      ModifiedByContactId: currentUser?.id || "00000000-0000-0000-0000-000000000000",
      ModifiedByContactName: currentUser?.fullName || "Unknown User",
      FormCategoryId: "00000000-0000-0000-0000-000000000000",
      FormCategoryName: "Unknown",
      FormSubCategoryId: "00000000-0000-0000-0000-000000000000",
      FormSubCategoryName: "Unknown",
      RecipientJobCategoryId: selectedJobCategory,
      RecipientJobCategoryName: jobCategories.find(cat => cat.jobCategoryId === selectedJobCategory)?.jobCategoryName || "All",
      RecipientContactId: selectedRecipient,
      RecipientContactName: recipients.find(recip => recip.id === selectedRecipient)?.name || "All",
      StatusReasonValue: 0,
      StatusReasonText: "",
      FormTypeValue: 0,
      FormTypeText: "",
      ForOneTimeUse: false,
      AllowSubmitterToAddComment: false,
      AllowReviewerToAddComment: false,
      AllowOthersToAddComment: false,
      AllowSubmitterToPrint: false,
      AllowReviewerToPrint: false,
      AllowOthersToPrint: false,
      AllowSubmitterToAddAttachment: false,
      AllowReviewerToAddAttachment: false,
      AllowOthersToAddAttachment: false,
      AllowSubmitterToSelectReviewer: false,
      AllowSubmitterToSelectRecipient: allowSubmitter || false,
      ApprovedOn: new Date().toISOString(),
      CreatedOn: new Date().toISOString(),
      ModifiedOn: new Date().toISOString(),
      ExpiryDate: new Date().toISOString(),
      PublishedOn: new Date().toISOString(),
    };

    api.post("/FormMaster/SetJobCategoryAndRecipient",  // Ensure this URL is correct!
      payload,
      { headers: { "Content-Type": "application/json" } }
    )
      .then(response => {
        debugger;
        closeModal();
        $.alert({
          title: 'Success',
          content: 'Record saved successfully.',
          type: 'green'
        });
       setLoading(true)// Redirect after save
      })
      .catch(error => {
        debugger;
        $.alert({
          title: 'Error',
          content: 'An error occurred while saving the settings.',
          type: 'red'
        });
      });



  }
  // If form or categories data is still loading
  if (!form || !formCategories.length || !formSubCategories.length) {
    return <Spinner />;
  }

  const backdropStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.2)", // light dark shade
  zIndex: 9998,
  cursor: "wait"  // cursor changes to loading
};

const overlayStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#222",
  padding: "30px 50px",
  borderRadius: "12px",
  zIndex: 9999,
  color: "#fff",
  fontSize: "22px",
  textAlign: "center",
  cursor: "wait" // cursor loading
};

  return (<>
    <div>
      {blocked && (
  <>
    {/* FULL SCREEN BACKDROP THAT BLOCKS CLICKS */}
    <div style={backdropStyle}></div>

    {/* CENTER BOX */}
    <div style={overlayStyle}>
      <div className="spinner-border" role="status"></div>
      <div>Please wait…</div>
    </div>
  </>
)}
      <div className="card card-success">
        <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h5>Status: {form.statusReasonText}</h5>
          <h5 style={{ marginLeft: 'auto' }}> <i className="fa fa-lock"></i> - Read Only</h5>
        </div>

        <div className="card-body">
          {/* Pass form data, categories, filtered sub-categories to the summary */}
          <FormMasterSummary
            form={form}
            formCategories={formCategories}
            formSubCategories={filteredSubCategories} // Pass filtered subcategories here
            selectedCategory={selectedCategory}
            onCategoryChange={handleCategoryChange}
            onFormChange={handleFormChange}
            shouldDisableFields={shouldDisableFields}
            formType={formType}
          // FetchFormData ={FetchFormData}
          />
        </div>

        <div className="card-footer">
          <button className="btn btn-danger mr-2" onClick={() => navigate('/editor/FormMasters')}>
            Close
          </button>
          <button className="btn btn-success"
            onClick={handleSaveSummary}
            disabled={shouldDisableFields}>
            Save
          </button> &nbsp;
          {/* Conditionally render the "Send for Approver" button */}

          {shouldShowButton && (
            <button
              className="btn btn-primary"
              onClick={handleSendForApprover}
            >
              Send for Approver
            </button>
          )}
          &nbsp;&nbsp;
          {showPreview || shouldShowButton && (
            <button
              className="btn btn-warning"
              onClick={handlePreviewClick}
            >
              Preview
            </button>
          )}

          &nbsp;&nbsp;
          {showSetRecipient || shouldShowButton && (
            <button 
            className="btn btn-success"
              onClick={openModal}
            >
              Set Recipients
            </button>
          )}

        </div>
      </div>
      {/* Add new card for Form Master Settings */}
      <div className="card card-success mt-4">
        <div className="card-header">
          <h5>Form Master Settings</h5>
        </div>

        <div className="card-body">
          {/* Pass form data and handle form changes for settings */}
          <FormMasterSettings
            form={form}
            onFormChange={handleFormChange}
            shouldDisableFields={shouldDisableFields}
          />
        </div>

        <div className="card-footer">
          <button className="btn btn-success"
            onClick={handleSaveSettings}
            disabled={shouldDisableFields}> 
            Save
          </button>
        </div>
      </div>
      
      <FormMasterJobCategories 
      formId={form.id}
        formMasterJobCategories={formMasterJobCategories}
        formJobCategories={formJobCategories}
        onJobCategoryAdded={handleJobCategoryAdded}
        onJobCategoryDeleted={handleJobCategoryDeleted}
        OnColumnnumberChange={OnColumnChange}
        handleSaveFromMasterSection={handleSaveFromMasterSection}
        shouldDisableFields={shouldDisableFields}
      />

      {formMasterSections && formMasterSections.length > 0 &&
        formMasterSections.map((section) => (
          <FormMasterSectionCard key={section.id} section={section} formMasterGuid={form.id}
            handleDeleteSection={handleDeleteSection}
            shouldDisableFields={shouldDisableFields} 
          setRefresh={setRefresh}
            />
        ))
      }

      <FormMasterCalculation
        formId={id}
        formMasterCalculations={formMasterCalculations}
        onCalculationAdded={handleCalculationAdded}
        onCalculationDeleted={onCalculationDeleted}
        shouldDisableFields={shouldDisableFields}
        Addcalculation={addCalculation}
      />
    </div>
    {/* Modal Popup */}
    <Modal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      contentLabel="Set Recipients"
      style={modalStyles}
    >
      <h2 style={styles.header}>Set Recipients</h2>

      {/* Job Category Dropdown */}
      <div style={styles.formGroup}>
        <label style={styles.label}>Job Category:</label>
        <select value={jobCategory} onChange={handleJobCategoryChange} style={styles.select}>
          <option value="">-- Select Job Category --</option>
          {jobCategories.map((category, index) => (
            <option key={index} value={category.id}>
              {category.name}  {/* ✅ Extracted string value */}
            </option>
          ))}
        </select>
      </div>

      {/* Recipients Dropdown (Disabled until Job Category is selected) */}
      <div style={styles.formGroup}>
        <label style={styles.label}>Recipients:</label>
        <select
          value={recipient}
          onChange={handleRecipientChange}
          disabled={!jobCategory}
          style={{
            ...styles.select,
            backgroundColor: jobCategory ? "white" : "#e9ecef",
            cursor: jobCategory ? "pointer" : "not-allowed",
          }}
        >
          {recipients.map((recip) => (
            <option key={recip.id} value={recip.id}>
              {recip.name} {/* ✅ Show name as option label */}
            </option>
          ))}
        </select>
      </div>

      {/* Allow Submitter to Select Recipients Checkbox */}
      {recipient === "all" && jobCategory && (
        <div style={styles.formGroup}>
          <input
            type="checkbox"
            checked={allowSubmitter}
            onChange={(e) => setAllowSubmitter(e.target.checked)}
          />
          <label style={{ marginLeft: "8px" }}>Allow Submitter to Select Recipients</label>
        </div>
      )}

      {/* Buttons */}
      <div style={styles.buttonContainer}>
        <button onClick={closeModal} style={styles.cancelButton}>
          Cancel
        </button>
        <button onClick={handleSave} style={styles.saveButton}>
          Save
        </button>
      </div>
    </Modal>
  </>
  );
};
// Styles
const styles = {
  button: {
    padding: "10px 15px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  header: {
    textAlign: "center",
    marginBottom: "15px",
  },
  formGroup: {
    marginBottom: "15px",
  },
  label: {
    fontWeight: "bold",
    display: "block",
  },
  select: {
    width: "100%",
    padding: "8px",
    borderRadius: "5px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  cancelButton: {
    padding: "10px 15px",
    backgroundColor: "#dc3545",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  saveButton: {
    padding: "10px 15px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

// Modal Styles
const modalStyles = {
  overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
  content: {
    width: "40%",
    margin: "auto",
    padding: "20px",
    borderRadius: "10px",
    border: "1px solid #ddd",
  },
};

export default FormMasterView;
